import { RidesharingAppEnum } from 'app/models';

export class RidesharingAppModel {
    public static RidesharingAppModelList: Array<any> = [
        { name: 'All', value: null },
        { name: 'Initial', value: RidesharingAppEnum.Initial },
        { name: 'None', value: RidesharingAppEnum.None },
        { name: 'Angkas', value: RidesharingAppEnum.Angkas },
        { name: 'Moveit', value: RidesharingAppEnum.Moveit },
        { name: 'Joyride', value: RidesharingAppEnum.Joyride },
        { name: 'Grab', value: RidesharingAppEnum.Grab },
        { name: 'Uber', value: RidesharingAppEnum.Uber },
        { name: 'Grab Express', value: RidesharingAppEnum.GrabExpress },
        { name: 'Lalamove', value: RidesharingAppEnum.Lalamove },
        { name: 'Happy Move', value: RidesharingAppEnum.HappyMove },
        { name: 'Transportify', value: RidesharingAppEnum.Transportify },
        { name: 'Others', value: RidesharingAppEnum.Others },
        { name: 'Food Panda', value: RidesharingAppEnum.FoodPanda },
        { name: 'Pick ARoo', value: RidesharingAppEnum.PickARoo },
        { name: 'Ding Dong', value: RidesharingAppEnum.DingDong },
        { name: 'Maxim', value: RidesharingAppEnum.Maxim }
    ];
}
